import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({ scaleX, fill, outline, gradient }) {
  const randomGradientId1 = `_${useRandomId()}`
  const randomGradientId2 = `_${useRandomId()}`

  return (
    <g transform={`scale(${scaleX},1)`}>
      <path
        d="M14.5335 8.80932C12.9035 4.45932 8.45345 0.0493188 4.84345 1.17932C1.32345 2.27932 -0.42655 10.2594 2.42345 16.5894C4.40345 20.9894 7.20345 23.6093 9.69345 22.7593C12.1735 21.9093 17.8335 17.6093 14.5335 8.80932Z"
        fill={fill}
        stroke={outline} // "#893F2B"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M3.30371 13.7394C3.30371 13.7394 3.31371 7.78943 5.78371 6.32943C8.24371 4.87943 12.4137 8.34944 12.3037 18.0294"
        fill={`url(#${randomGradientId1})`}
      />
      <path
        d="M3.30359 13.7394C3.18359 11.7794 3.28359 9.7594 4.06359 7.8394C4.45359 6.9194 5.17359 5.88936 6.38359 5.60936C7.58359 5.32936 8.71358 5.92939 9.48358 6.63939C11.0436 8.13939 11.7436 10.1494 12.1336 12.0994C12.5236 14.0694 12.5236 16.0694 12.3136 18.0294C12.1336 16.0694 11.8536 14.1294 11.3636 12.2794C11.1036 11.3594 10.8036 10.4494 10.3836 9.60936C9.98359 8.75936 9.46359 7.97937 8.81359 7.36937C8.17359 6.75937 7.3536 6.37938 6.5736 6.50938C5.7936 6.62938 5.17359 7.34941 4.74359 8.15941C3.90359 9.82941 3.54359 11.7994 3.30359 13.7394Z"
        fill={outline}
      />
      <path
        d="M72.3837 8.80932C74.0137 4.45932 78.4637 0.0493188 82.0737 1.17932C85.5937 2.27932 87.3437 10.2594 84.4937 16.5894C82.5137 20.9894 79.7137 23.6093 77.2237 22.7593C74.7337 21.9093 69.0837 17.6093 72.3837 8.80932Z"
        fill={fill}
        stroke={outline} // "#893F2B"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M83.6135 13.7394C83.6135 13.7394 83.6035 7.78943 81.1335 6.32943C78.6735 4.87943 74.5035 8.34944 74.6135 18.0294"
        fill={`url(#${randomGradientId2})`}
      />
      <path
        d="M83.6135 13.7394C83.3735 11.7994 83.0035 9.82942 82.1735 8.16942C81.7435 7.35942 81.1235 6.64939 80.3435 6.51939C79.5735 6.37939 78.7435 6.75938 78.1035 7.37938C77.4535 7.98938 76.9335 8.76937 76.5335 9.61937C76.1135 10.4594 75.8135 11.3694 75.5535 12.2894C75.0635 14.1394 74.7935 16.0794 74.6035 18.0394C74.3935 16.0794 74.3935 14.0794 74.7835 12.1094C75.1735 10.1594 75.8735 8.1494 77.4335 6.6494C78.2035 5.9394 79.3335 5.33937 80.5335 5.61937C81.7435 5.89937 82.4535 6.91941 82.8535 7.84941C83.6335 9.74941 83.7235 11.7794 83.6135 13.7394Z"
        fill={outline}
      />
      <defs>
        <radialGradient
          id={randomGradientId1}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(9.75129 10.5234) rotate(145.174) scale(4.95118 7.26698)"
        >
          <stop stopColor={gradient[0]} />
          <stop offset="1" stopColor={gradient[1]} />
        </radialGradient>
        <radialGradient
          id={randomGradientId2}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(77.0445 10.6218) rotate(34.8264) scale(4.95118 7.26698)"
        >
          <stop stopColor={gradient[0]} />
          <stop offset="1" stopColor={gradient[1]} />
        </radialGradient>
      </defs>
    </g>
  )
}
